import { intlLocale } from '@/i18n'
import type { Assignment, Submission } from './types'

export type WorkStatus = 'missing' | 'overdue' | 'submitted' | 'late' | 'graded'

/** Where a student stands on an assignment. */
export function workStatus(
  assignment: Pick<Assignment, 'dueAt'>,
  submission: Submission | null,
  now = new Date(),
): WorkStatus {
  if (!submission) return new Date(assignment.dueAt) < now ? 'overdue' : 'missing'
  if (submission.gradedAt) return 'graded'
  return submission.late ? 'late' : 'submitted'
}

export const workStatusMeta: Record<
  WorkStatus,
  { label: string; tone: 'neutral' | 'danger' | 'info' | 'warning' | 'success' }
> = {
  missing: { label: 'To hand in', tone: 'neutral' },
  overdue: { label: 'Not handed in', tone: 'danger' },
  submitted: { label: 'Handed in', tone: 'info' },
  late: { label: 'Handed in late', tone: 'warning' },
  graded: { label: 'Graded', tone: 'success' },
}

export function lmsBase(portal: string | null): string {
  return portal === 'staff' ? '/staff/lms' : '/admin/lms'
}

/** "15 / 20" or "—". */
export function formatPoints(points: number | null, max: number | null): string {
  if (points === null) return '—'
  const n = new Intl.NumberFormat(intlLocale(), { maximumFractionDigits: 2 }).format(points)
  return max !== null ? `${n} / ${max}` : n
}
